import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const inputId = this.element.getAttribute("data-password-checker-input-value")

    this.checkPasswordStrength(inputId);
    document.getElementById(inputId).addEventListener('input', () => {
      this.checkPasswordStrength(inputId); // Verificar la fortaleza de la contraseña cada vez que el valor del input cambia
    });
  }

  disconnect() {}

  updateCriteriaIcon(criteriaId, isValid) {
    const iconElement = document.getElementById(criteriaId);
    iconElement.className = isValid ? 'fa fa-check text-green-500' : 'fa fa-times text-red-500';
  }

  checkPasswordStrength(inputId) {
    const password = document.getElementById(inputId).value;
    let strength = 0;

    // Check if password length is 8 characters or more
    const isLongEnough = password.length >= 8;
    this.updateCriteriaIcon('criteria-length', isLongEnough);
    if (isLongEnough) strength += 1;

    // Check for digits
    const hasDigit = /\d/.test(password);
    this.updateCriteriaIcon('criteria-digit', hasDigit);
    if (hasDigit) strength += 1;

    // Check for lowercase letters
    const hasLowercase = /[a-z]/.test(password);
    this.updateCriteriaIcon('criteria-lowercase', hasLowercase);
    if (hasLowercase) strength += 1;

    // Check for uppercase letters
    const hasUppercase = /[A-Z]/.test(password);
    this.updateCriteriaIcon('criteria-uppercase', hasUppercase);
    if (hasUppercase) strength += 1;

    // Check for special characters
    const hasSpecialChar = /[^A-Za-z0-9]/.test(password);
    this.updateCriteriaIcon('criteria-special', hasSpecialChar);
    if (hasSpecialChar) strength += 1;

    // Check for entropy (this is a simplified entropy check, a real check would be more complex)
    const hasHighEntropy = (new Set(password)).size >= 10;
    this.updateCriteriaIcon('criteria-entropy', hasHighEntropy);
    if (hasHighEntropy) strength += 1;

    // Update the password strength bar
    const strengthBar = document.getElementById('password-strength');
    switch (strength) {
      case 1:
        strengthBar.style.width = '20%';
        strengthBar.className = 'h-2.5 rounded-full bg-red-500 transition-width duration-300 ease-in-out';
        break;
      case 2:
        strengthBar.style.width = '40%';
        strengthBar.className = 'h-2.5 rounded-full bg-orange-500 transition-width duration-300 ease-in-out';
        break;
      case 3:
        strengthBar.style.width = '60%';
        strengthBar.className = 'h-2.5 rounded-full bg-yellow-500 transition-width duration-300 ease-in-out';
        break;
      case 4:
        strengthBar.style.width = '80%';
        strengthBar.className = 'h-2.5 rounded-full bg-blue-500 transition-width duration-300 ease-in-out';
        break;
      case 5:
        strengthBar.style.width = '100%';
        strengthBar.className = 'h-2.5 rounded-full bg-green-500 transition-width duration-300 ease-in-out';
        break;
      default:
        strengthBar.style.width = '0';
        strengthBar.className = 'h-2.5 rounded-full bg-transparent transition-width duration-300 ease-in-out';
    }

    const submitButton = document.getElementById('submit_id')
    const disabledSubmitButton = document.getElementById('disabled_submit_id')

    if (strength < 5) {
      submitButton.style.display = 'none';
      disabledSubmitButton.style.display = 'block';
    } else {
      submitButton.style.display = 'block';
      disabledSubmitButton.style.display = 'none';
    }
  }
}
